import { useEffect } from "react";

/**
 * Inject a JSON-LD script tag into <head> for the current page.
 * The `id` scopes the tag so navigating between pages cleanly replaces it.
 *
 * Usage:
 *   useJsonLd("route-schema", schemaObjectOrArray);
 *
 * Pass `null` or `undefined` to skip / remove.
 */
export default function useJsonLd(id, data) {
  useEffect(() => {
    const elementId = `ld-${id}`;
    // Remove existing tag with same id, then re-add (avoids stale content on navigation)
    document.querySelectorAll(`script[data-ld-id="${elementId}"]`).forEach((el) => el.remove());
    if (!data) return undefined;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.ldId = elementId;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id, data]);
}
